<template>
  <div class="wrapper">
    <ul class="orderBody">
      <li class="item">
        <span class="title_tag">场馆名称:</span>
        <span class="title">{{detail.stname}}</span>
      </li>
      <li class="item">
        <span class="title_tag">场馆地点:</span>
        <span class="title">{{detail.address}}</span>
      </li>
      <li class="item"><span class="title_tag">预订信息:</span><span class="title">{{detail.info}}</span></li>


      <li class="item"><span class="title_tag"></span><span class="title"></span></li>
      <li class="item"><span class="title_tag">支付金额:</span><span class="title">￥{{detail.free}}</span></li>
      <li class="item"><span class="title_tag">支付时间:</span><span class="title">{{detail.paytime}}</span></li>
      <li class="item"><span class="title_tag">支付方式:</span><span class="title">微信支付</span></li>
      <li class="item"><span class="title_tag">交易单号:</span><span class="title">{{detail.orderno}}</span></li>
      <li class="item"><span class="title_tag">支付单号:</span><span class="title">{{detail.tradeno}}</span></li>

    </ul>
    <div class="venue-list"  v-if="detail.state != '9'">
      <section class="venue-info weui-media-box weui-media-box_appmsg" v-for="(item,index) in detail.stadiumOrderDetail" :key="index">
        <div class="weui-media-box__bd">
          <h4 class="weui-media-box__title" v-html="(index+1)+'、'+item.subname"></h4>
          <p class="weui-media-box__desc" style="padding-left: .2rem;" v-html="item.timeinfos"></p>
        </div>
        <div class="weui-cell__ft">
          <Button type="warning" size="mini" @click.native="check(item,1)" v-if="item.state == 1">核验</Button>
          <!--<x-button type="primary" mini @click.native="check(detail,2)" v-if="detail.state == 2">撤销核验</x-button>-->
        </div>
      </section>
    </div>
    <div class="orderinfo" v-else style="text-align: center;margin-top: 20px">
      <span>订单已退订</span>
    </div>
  </div>
</template>

<script>

    import {isWeiXin} from "@/libs/utils";
    import {getDetail,available,payprepayorder,paypayorder,orderinfo,checkin} from '@/libs/api.js'
    import {NumberKeyboard, Field,Form,Button,CouponCell, CouponList,Popup} from "vant";
    import { getLastRouter, goBack, setStorage, islogin, userinfo,getStorage} from '@/libs/utils'
    export default {
        name: "index",
        data() {
            return {
                show: false,
                loading: false,
                money:'',
                stid:'',
                detail:{},
                showList:false,
                showOrder:false,
                orderdetail:{},
                shipment:{},
                coupons:[],
                chosenCoupon: 0,
                orderpay:{}
            };
        },
        components: {
            NumberKeyboard,
            Field,
            Form,
            Button,CouponCell, CouponList,Popup
        },
        methods: {
            getDetail: function () {
                orderinfo(this.orderpay).then((res)=>{
                    if(res.status*1==200){
                      let free = res.data.fee/100
                      res.data.free = free.toFixed(2);
                        this.detail =  res.data
                    }
                })
            },
            check(item,op){
              this.orderpay.detailid = item.detailid
              checkin(this.orderpay).then((res)=>{
                if (res.status*1 == 200)
                { 
                  this.$dialog.alert({
                    message: res.message,
                  });
                  this.getDetail()
                }
              })
            }
        },
        mounted() {
            this.$nextTick(() => {
              this.isweixin = isWeiXin()
              let orderpay = window.localStorage.getItem('orderpay');
              this.orderpay = JSON.parse(orderpay)
              this.getDetail()
            })

        }


    };
</script>

<style scoped lang="less">
  .wrapper{
    background: #f0f0f0;
    /*background: red;*/
    position: absolute;
    min-height: 100%;
    width: 100%;
    .orderBody{
      /*width: 100%;*/
      padding: .6rem .3rem;
      height: 13.6rem;
      background: white;
      .item{
        /*border-bottom: 1px solid;*/
        /*background: red;*/
        font-size: .7rem;
        padding: .2rem .1rem;
        display: flex;
        position: relative;
        font-weight: 400;
        .title_tag{
          width: 3.4rem;
          flex-shrink: 0;
          text-align: center;
          border-right: 1px solid white;
          color: #9b9b9b;
        }
        .title{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: initial;
          color: #3b3b3b;
          text-align: right;
          position: absolute;
          left: 3.8rem;
          right: .3rem;
        }
      }
      .item:nth-child(4){
        height: 0;
        margin-top: .8rem;
        margin-bottom: .3rem;
        border-top: 1px solid #dedede;
      }
    }
    .qrWrapper{
      width: 10rem;
      height: 10rem;
      background: white;
      margin-right: auto;
      margin-left: auto;
      margin-top: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      .qrcontain{
        background: #f0f0f0;
        width: 88%;
        height: 88%;
      }
    }
    .venue-list{
      margin-top: .6rem;
      background:#ffffff;
      font-size: .7rem;
      width: 100%;
      .venue-info{
        display:flex;
        align-items:center;
        justify-content: space-between;
        padding:.3rem;
        >div{
          display:flex;
          align-items:center;
        }
      }
    }
  }

</style>
